// Configuration defaults for ChatWidget
export const DEFAULT_CONFIG = {
    apiEndpoint: '/api/query',
    botName: 'AI Assistant',
    botStatus: 'Online',
    welcomeMessage: 'Hi! I\'m your AI assistant. How can I help you today?',
    placeholder: 'Type your message...',
    openOnLoad: true,
    openOnLoadDelay: 0,  // delay in seconds before auto-opening (desktop only)
    initialDisplayMode: 'closed',  // "closed", "nudge", or "open"
    nudgeTitle: 'Need help?',
    nudgeText: 'Chat with our AI assistant',
    nudgeDelay: 3,  // seconds before nudge appears
    nudgeDuration: 0,  // seconds before auto-dismiss (0 = never)
    responseSizeLimit: 0,
    maxHeightDesktop: '800px',
    color: '#667eea',
    mobileNotificationTitle: 'Need help?',
    mobileNotificationText: 'Chat with our AI assistant',
    botIcon: '🤖',
    suggestedQuestions: [],
    previewMode: false  // Admin preview mode - uses /api/query-preview endpoint to test draft flows
};
